import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner"; // Add this import
import { AuthProvider } from "./context/AuthContext";
import { LocationProvider } from "./context/LocationContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import Home from "./pages/Home";
import Doctors from "./pages/Doctors";
import Pharmacy from "./pages/Pharmacy";
import Lab from "./pages/Lab";
import Vitals from "./pages/Vitals";
import Auth from "./pages/Auth";
import Account from "./pages/Account";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import Nutrition from "./pages/Nutrition";
import Insurance from "./pages/Insurance";
import Privacy from "./pages/Privacy";

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <div className="App">
          <BrowserRouter>
            <Header />
            <main className="min-h-screen">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/doctors" element={<Doctors />} />
                <Route path="/pharmacy" element={<Pharmacy />} />
                <Route path="/lab" element={<Lab />} />
                <Route path="/nutrition" element={<Nutrition />} />
                <Route path="/insurance" element={<Insurance />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route
                  path="/vitals"
                  element={
                    <ProtectedRoute>
                      <Vitals />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/account"
                  element={
                    <ProtectedRoute>
                      <Account />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <Footer />
            {/* Add Sonner Toaster */}
            <Toaster
              position="top-right"
              duration={3000}
              closeButton
              richColors
            />
          </BrowserRouter>
        </div>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
